export default __webpack_public_path__ + "static/media/IconPhone.021038b1.svg";